import {
  AnalyticsIdentifyProperties,
  AnalyticsPageProperties,
  AnalyticsTrackProperties,
} from './analyticsTypes'
import { PostHogAnalytics } from './postHog'

export const DEFAULT_ANALYTICS_PAGE_CATEGORY = 'Admin App'

export class AnalyticsManager {
  private postHog: PostHogAnalytics

  constructor() {
    this.postHog = new PostHogAnalytics()
  }

  async load() {
    await Promise.all([this.postHog.load()])
  }

  isLoaded() {
    return this.postHog.isLoaded()
  }

  async identifyUser(identifyProperties: AnalyticsIdentifyProperties) {
    await Promise.all([this.postHog.identifyUser(identifyProperties)])
  }

  async pageViewed(pageName: string, options?: AnalyticsPageProperties) {
    await Promise.all([this.postHog.pageViewed(pageName, options)])
  }

  async trackEvent(eventName: string, properties?: AnalyticsTrackProperties) {
    await Promise.all([this.postHog.trackEvent(eventName, properties)])
  }
}

export type {
  AnalyticsIdentifyProperties,
  AnalyticsPageProperties,
  AnalyticsTrackProperties,
}
